import * as React from "react"
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import {NavigationBar, Layout} from "./layout"
import mahaStupa from "./assets/mahaStupa.png"
import vesak from "./assets/vesak_orig.jpg"
import guanyinBirthday from "./assets/guanyin-birthday.png"
import SummerChanQi from "./assets/chanqi-thumb-summer-2025.jpg";
import SummerFoQi from "./assets/foqi-thumb-summer-2025.jpg";
import Table from 'react-bootstrap/Table';
import GuanYinEnlightenment from "./assets/guanyin-enlightenment-letter.png";
import GuanYinLeftHome from "./assets/guanyinlh-letter.png";
import Ullambana from "./assets/ullambana.png";
import MedicineMasterBuddhaBirthday from "./assets/medicine-master-buddha-letter.png";
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import { Typography, Box, Stack } from "@mui/material";
import { useLocation, Link } from 'react-router-dom';
import { useEffect } from 'react';


export const events=[{
    "title": "幽冥戒法會",
    "dateBegin": "2025-03-29 15:00",
    "dateEnd": "2025-03-29 16:30",
"poster": "ceremony-for-the-deceased_orig.png",
"thumbnail": "ceremony-for-the-deceased_orig.png",
"html": <><Typography variant="h3" style={{textAlign:"center"}}>Ceremony For Precepts Transmission For the Deceased</Typography>
<Typography variant="body1" style={{textAlign:"center"}}>
Purpose: To offer deceased individuals the opportunity to repent their karmic offenses, take refuge in the Triple Jewel, and receive Buddhist precepts. Through this, they can transcend suffering, receive coolness, attain clarity and peace, and embark on the path of Buddhist practice.<br/><br/>
Date: Saturday, March 29, 2025<br/><br/>
Time: 3pm - 4:30pm PST<br/><br/>
Location: Dharma Treasury Temple<br/><br/>
To request precepts transmission to a deceased person, use these links:
In the US and other countries: <a href="">Click Here</a><br/><br/>
In South Korea: <a href="">Click Here </a><br/><br/>
Last date to request: March 08, 2025<br/><br/>
For any questions and inquiries,<br/>
please <a href="mailto:dp-plaque@bodhilight.net">Click Here</a> to email <br/>
(中文: 賢前師 / Korean: Ven XianPu / Vietnamese: Ven XianLai)<br/><br/><br/><br/>
Requesters can attend the ceremony at a BLI temple or online.</Typography></>
},
{
    "title": "大悲懺",
    "dateBegin": "2025-03-30 08:00",
    "dateEnd": "2025-03-30 09:40",
    "poster": "gcr-march-30_orig.jpg",
    "thumbnail": "gcr-march-30_orig.jpg",
    "html":<>
    <Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 3月30日星期日 早上8:00<br/>
      <b>地點：</b><Link to="/location" >溈山寺，金林寺，法藏寺</Link><br/>
    </Typography></>
},
{
    "title": "大悲懺",
    "dateBegin": "2025-04-27 08:00",
    "dateEnd": "2025-04-27 09:40",
    "poster": "gcr-april-27_orig.jpg",
    "thumbnail": "gcr-april-27_orig.jpg",
    "html":<>
    <Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 4月27日星期日 早上8:00<br/>
      <b>地點：</b><Link to="/location" >溈山寺，金林寺，法藏寺</Link><br/>
    </Typography></>
},
{
    "title": "藥師佛寶懺",
    "dateBegin": "2025-04-13 08:00",
    "dateEnd": "2025-04-13 16:00",
    "poster": "mmb-rep-april-13_orig.jpg",
    "thumbnail": "mmb-rep-april-13_orig.jpg",
    "html": <><Typography variant="body1" style={{textAlign:"center"}}>8am - 9:40 am<br/><a href="https://www.chanpureland.org/uploads/5/5/7/7/55776393/mmbr_-_roll_1.pdf">Click here for Roll 1</a><br/>9:40 - Dharma Talk<br/>11 - Vegetarian Lunch<br/>12:30 - 1:50pm<br/><a href="https://www.chanpureland.org/uploads/5/5/7/7/55776393/mmbr_roll_2.pdf">Click here for Roll 2</a><br/>2 - 3:40pm<br/><a href="https://www.chanpureland.org/uploads/5/5/7/7/55776393/mmbr_roll_3.pdf">Click here for Roll 3</a><br/>​Location:<br/><Link to="/location" >
Wei Mountain Temple - Rosemead<br/>
Dharma Treasury Temple - San Francisco</Link></Typography><br/></>
},
{
    "title": "大悲懺",
    "dateBegin": "2025-05-25 08:00",
    "dateEnd": "2025-05-25 09:40",
    "poster": "gcr-may-25_orig.jpg",
    "thumbnail": "gcr-may-25_orig.jpg",
    "html":<>
    <Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 5月25日星期日 早上8:00<br/>
      <b>地點：</b><Link to="/location" >溈山寺，金林寺，法藏寺</Link><br/>
    </Typography></>
},
{
    "title": "大悲懺",
    "dateBegin": "2025-06-08 08:00",
    "dateEnd": "2025-06-08 09:40",
    "poster": "gcr-june-8_orig.jpg",
    "thumbnail": "gcr-june-8_orig.jpg",
    "html":<>
    <Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 6月8日星期日 早上8:00<br/>
      <b>地點：</b><Link to="/location" >溈山寺，金林寺，法藏寺</Link><br/>
    </Typography></>
},

{
    "title": "大悲懺",
    "dateBegin": "2025-06-29 08:00",
    "dateEnd": "2025-06-29 09:40",
    "poster": "gcr-june-29_orig.jpg",
    "thumbnail": "gcr-june-29_orig.jpg",
    "html":<>
    <Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 6月29日星期日 早上8:00<br/>
      <b>地點：</b><Link to="/location" >溈山寺，金林寺，法藏寺</Link><br/>
    </Typography></>
},

{
    "title": "觀音菩薩成道日",
    "dateBegin": "2025-07-13 08:00",
    "dateEnd": "2025-07-13 09:40",
    "poster": "guanyin-enlightenment-letter-vertical-3_orig.jpg",
    "thumbnail": "guanyinlh-thumbnail_orig.png",
    "html": <><b>日期：</b> 7月13日星期日<br/><b>時間：</b> 早上8:00<br/><b>地點：</b> <Link to="/location" >溈山寺，金林寺，法藏寺</Link><br/></>
},
{
    "title": "藥師佛誕辰",
    "dateBegin": "2025-11-16 08:00",
    "dateEnd": "2025-11-16 09:40",
    "poster": "medicine-master-buddha-letter-vertical-10_orig.jpg",
    "thumbnail": "medicine-master-buddha-letter-vertical-10_orig.jpg",
    "html": <><b>日期：</b> 11月16日星期日<br/><b>時間：</b> 早上8:00<br/><b>地點：</b> <Link to="/location" >溈山寺，金林寺，法藏寺</Link><br/></>
},
{
    "title": "觀音菩薩聖誕日",
    "dateBegin": "2025-03-17 08:00",
    "dateEnd": "2025-03-17 09:40",
    "poster": "guanyin-enlightenment-letter-vertical-3_orig.jpg",
    "thumbnail": "guanyinbirthday-thumbnail.png",
    "html": <><Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 3月24日星期日
      <br/>
      <b>時間：</b> 早上8點
      <br/>
    </Typography></>
},
{
    "title": "浴佛節",
    "dateBegin": "2025-05-04 08:00",
    "dateEnd": "2025-05-04 11:00",
    "poster": "vesak_orig.jpg",
    "thumbnail": "vesak_orig.jpg",
    "html": <><b>日期：</b> 5月4日星期日 早上8:00<br/><b>地點：</b> <Link to="/location" >法藏寺，金林寺，溈山寺</Link><br/></>
},

{
    "title": "佛七",
    "dateBegin": "2025-06-21 13:00",
    "dateEnd": "2025-06-28 11:00",
    "poster": "summer-foqi-2025_orig.png",
    "thumbnail": "foqi-thumb-summer-2025.jpg",
    "html": <>
    <Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 6月14日星期六-6月21日星期六<br/>
      <b>地點：</b>
        <Link to="/location" >
          溈山寺，金林寺，法藏寺
        </Link><br/>
    </Typography>
    <br/><Link to="/foqi" >
      <div style={{display: "flex", justifyContent: "center"}}>
        <Button style={{ background: "#282c34", color: "white",  }}>了解更多</Button>
      </div>
    </Link></>
},{
    "title": "禪七",
    "dateBegin": "2025-06-28 21:00",
    "dateEnd": "2025-07-12 11:00",
    "poster": "summer-chanqi-2025_orig.png",
    "thumbnail": "chanqi-thumb-summer-2025.jpg",
    "html": <>
    <Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 6月28日星期六-7月12日星期六<br/>
      <b>地點：</b>
        <Link to="/location" >
          溈山寺，金林寺，法藏寺
        </Link><br/>
    </Typography>
    <br/><Link to="/chanqi" >
      <div style={{display: "flex", justifyContent: "center"}}>
        <Button style={{ background: "#282c34", color: "white",  }}>了解更多</Button>
      </div>
    </Link></>
},
{
    "title": "藥師佛寶懺",
    "dateBegin": "2025-07-27 08:00",
    "dateEnd": "2025-07-27 16:00",
    "poster": "medicine-master-buddha-re-july-27_orig.jpg",
    "thumbnail": "medicine-master-buddha-re-july-27_orig.jpg",
    "html": <><Typography variant="body1" style={{textAlign:"center"}}>8am - 9:40 am<br/><a href="https://www.chanpureland.org/uploads/5/5/7/7/55776393/mmbr_-_roll_1.pdf">Click here for Roll 1</a><br/>9:40 - Dharma Talk<br/>11 - Vegetarian Lunch<br/>12:30 - 1:50pm<br/><a href="https://www.chanpureland.org/uploads/5/5/7/7/55776393/mmbr_roll_2.pdf">Click here for Roll 2</a><br/>2 - 3:40pm<br/><a href="https://www.chanpureland.org/uploads/5/5/7/7/55776393/mmbr_roll_3.pdf">Click here for Roll 3</a><br/>​Location:<br/><Link to="/location" >
Wei Mountain Temple - Rosemead<br/>
Dharma Treasury Temple - San Francisco</Link></Typography><br/></>
},
{
    "title": "大悲懺",
    "dateBegin": "2025-08-17 08:00",
    "dateEnd": "2025-08-17 09:40",
    "poster": "gcr-aug-17_orig.jpg",
    "thumbnail": "gcr-aug-17_orig.jpg",
    "html":<>
    <Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 8月17日星期日 早上8:00<br/>
      <b>地點：</b><Link to="/location" >溈山寺，金林寺，法藏寺</Link><br/>
    </Typography></>
},
{
    "title": "盂蘭盆節",
    "dateBegin": "2025-08-24 08:00",
    "dateEnd": "2025-08-24 11:00",
    "poster": "ullambana-letter-vertical-8_orig.jpg",
    "thumbnail": "ullambana-letter-vertical-8_orig.jpg",
    "html": <><b>日期：</b> 8月24日星期日 早上8:00<br/><b>地點：</b> <Link to="/location" >法藏寺，金林寺，溈山寺</Link><br/></>
},
{
    "title": "粱皇寳懺",
    "dateBegin": "2025-08-30 08:00",
    "dateEnd": "2025-09-05 17:00",
    "poster": "emperorliang-repentance_orig.png",
    "thumbnail": "emperorliang-repentance_orig.png",
    "html": <><b>日期：</b> 8月30日-9月5日<br/><b>地點：</b>溈山寺<br/><b>日程：</b><br/>4:00: 早課<br/>
8:00: 早場開始<br/>
11:00: 午齋<br/>
13:00: 下午場開始<br/>
18:00: 晚課<br/>
19:20: 講法<br/></>
},
{
    "title": "大悲懺",
    "dateBegin": "2025-09-28 08:00",
    "dateEnd": "2025-09-28 09:40",
    "poster": "gcr-sept-28_orig.jpg",
    "thumbnail": "gcr-sept-28_orig.jpg",
    "html":<>
    <Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 9月28日星期日 早上8:00<br/>
      <b>地點：</b><Link to="/location" >溈山寺，金林寺，法藏寺</Link><br/>
    </Typography></>
},
{
    "title": "藥師佛寶懺",
    "dateBegin": "2025-10-05 08:00",
    "dateEnd": "2025-10-05 16:00",
    "poster": "medicine-master-buddha-reoct-5_orig.jpg",
    "thumbnail": "medicine-master-buddha-reoct-5_orig.jpg",
    "html": <><Typography variant="body1" style={{textAlign:"center"}}>8am - 9:40 am<br/><a href="https://www.chanpureland.org/uploads/5/5/7/7/55776393/mmbr_-_roll_1.pdf">Click here for Roll 1</a><br/>9:40 - Dharma Talk<br/>11 - Vegetarian Lunch<br/>12:30 - 1:50pm<br/><a href="https://www.chanpureland.org/uploads/5/5/7/7/55776393/mmbr_roll_2.pdf">Click here for Roll 2</a><br/>2 - 3:40pm<br/><a href="https://www.chanpureland.org/uploads/5/5/7/7/55776393/mmbr_roll_3.pdf">Click here for Roll 3</a><br/>​Location:<br/><Link to="/location" >
Wei Mountain Temple - Rosemead<br/>
Dharma Treasury Temple - San Francisco</Link></Typography><br/></>
},
{
    "title": "大悲懺",
    "dateBegin": "2025-10-26 08:00",
    "dateEnd": "2025-10-26 09:40",
    "poster": "gcr-oct-26_orig.jpg",
    "thumbnail": "gcr-oct-26_orig.jpg",
    "html":<>
    <Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 10月26日星期日 早上8:00<br/>
      <b>地點：</b><Link to="/location" >溈山寺，金林寺，法藏寺</Link><br/>
    </Typography></>
},
{
    "title": "觀音菩薩出家日",
    "dateBegin": "2025-11-02 08:00",
    "dateEnd": "2025-11-02 09:40",
    "poster": "gy-leavin-ghome_orig.jpg",
    "thumbnail": "gy-leavin-ghome_orig.jpg",
    "html": <><Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 11月2日星期日
      <br/>
      <b>時間：</b> 早上8點
      <br/>
    </Typography></>
},
{
    "title": "藥師佛聖誕",
    "dateBegin": "2025-11-16 08:00",
    "dateEnd": "2025-11-16 09:40",
    "poster": "medicine-master-buddha-letter-vertical-10_orig.jpg",
    "thumbnail": "medicine-master-buddha-letter-vertical-10_orig.jpg",
    "html": <><Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 11月16日星期日
      <br/>
      <b>時間：</b> 早上8點
      <br/>
    </Typography></>
},
{
    "title": "大悲懺",
    "dateBegin": "2025-11-30 08:00",
    "dateEnd": "2025-11-30 09:40",
    "poster": "gcr-nov-30_orig.jpg",
    "thumbnail": "gcr-nov-30_orig.jpg",
    "html":<>
    <Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 11月30日星期日 早上8:00<br/>
      <b>地點：</b><Link to="/location" >溈山寺，金林寺，法藏寺</Link><br/>
    </Typography></>
},
{
    "title": "藥師佛寶懺",
    "dateBegin": "2025-12-14 08:00",
    "dateEnd": "2025-12-14 16:00",
    "poster": "medicine-master-buddha-repdec-14_orig.jpg",
    "thumbnail": "medicine-master-buddha-repdec-14_orig.jpg",
    "html": <><Typography variant="body1" style={{textAlign:"center"}}>8am - 9:40 am<br/><a href="https://www.chanpureland.org/uploads/5/5/7/7/55776393/mmbr_-_roll_1.pdf">Click here for Roll 1</a><br/>9:40 - Dharma Talk<br/>11 - Vegetarian Lunch<br/>12:30 - 1:50pm<br/><a href="https://www.chanpureland.org/uploads/5/5/7/7/55776393/mmbr_roll_2.pdf">Click here for Roll 2</a><br/>2 - 3:40pm<br/><a href="https://www.chanpureland.org/uploads/5/5/7/7/55776393/mmbr_roll_3.pdf">Click here for Roll 3</a><br/>​Location:<br/><Link to="/location" >
Wei Mountain Temple - Rosemead<br/>
Dharma Treasury Temple - San Francisco</Link></Typography><br/></>
},
{
    "title": "大悲懺",
    "dateBegin": "2025-12-21 08:00",
    "dateEnd": "2025-12-21 09:40",
    "poster": "gcr-dec-21_orig.jpg",
    "thumbnail": "gcr-dec-21_orig.jpg",
    "html":<>
    <Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 12月21日星期日 早上8:00<br/>
      <b>地點：</b><Link to="/location" >溈山寺，金林寺，法藏寺</Link><br/>
    </Typography></>
},
{
    "title": "佛七",
    "dateBegin": "2025-12-27 13:00",
    "dateEnd": "2026-01-03 11:00",
    "poster": "summer-foqi-2025_orig.png",
    "thumbnail": "foqi-thumb-summer-2025.jpg",
    "html": <>
    <Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 12月27日星期六-1月3日（2026年）星期六<br/>
      <b>地點：</b>
        <Link to="/location" >
          溈山寺，金林寺，法藏寺
        </Link><br/>
    </Typography>
    <br/><Link to="/foqi" >
      <div style={{display: "flex", justifyContent: "center"}}>
        <Button style={{ background: "#282c34", color: "white",  }}>了解更多</Button>
      </div>
    </Link></>
},
{
    "title": "阿彌陀佛聖誕",
    "dateBegin": "2025-12-31 08:00",
    "dateEnd": "2025-12-31 09:40",
    "poster": "amitabha-buddha-s-birthday-6_orig.jpg",
    "thumbnail": "amitabha-buddha-s-birthday-6_orig.jpg",
    "html": <><Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 1月4日（2026年）星期日
      <br/>
      <b>時間：</b> 早上8點
      <br/>
    </Typography></>
},




];

function UpcomingEvents () {
  const monthTextSize="0.85rem"
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);

  const getEventsInMonth=(k)=> {
    return events.filter(event => {
        const startDate = new Date(event.dateBegin);
        return startDate.getMonth() === k;
    });
}


  return (
    <><NavigationBar/>
      {/* Hero Image */}
<div style={{ display: "grid" }}>
      <img
        style={{
          gridArea: "1/1",
          // maxHeight: 600,
        }}
        layout="fullWidth"
        aspectRatio={3 / 1}
        alt=""
        src="/eventBanner.png"
        />
      <div
        style={{
          gridArea: "1/1",
          position: "relative",
          placeItems: "center",
          display: "grid",
        }}
      >
      </div>
    </div>
    {/* Main Content */}
  <Layout>
  <Table style={{tableLayout: "fixed"}}><tbody>
  <tr><td><Link to="/upcoming-events#jan"><Typography variant="body1" fontSize="0.8rem">一月</Typography></Link>
    </td><td/><td>
    <Link to="/upcoming-events#feb"><Typography variant="body1" fontSize="0.8rem">二月</Typography></Link>
    </td><td/><td><Link to="/upcoming-events#mar"><Typography variant="body1" fontSize="0.8rem">三月</Typography>  </Link></td><td/>
     <td><Link to="/upcoming-events#apr"><Typography variant="body1" fontSize="0.8rem">四月</Typography>   </Link>
     </td></tr>
       <tr><td>    <Link to="/upcoming-events#may"><Typography variant="body1" fontSize="0.8rem">五月</Typography>  </Link>

    </td><td/><td>
    <Link to="/upcoming-events#jun"><Typography variant="body1" fontSize="0.8rem">六月</Typography></Link>
    </td><td/><td>
    <Link to="/upcoming-events#jul"><Typography variant="body1" fontSize="0.8rem">七月</Typography> </Link>
    </td><td/>
     <td><Link to="/upcoming-events#aug"><Typography variant="body1" fontSize="0.8rem">八月</Typography>  </Link>
     </td></tr>
       <tr><td><Link to="/upcoming-events#sep"><Typography variant="body1" fontSize="0.8rem">九月</Typography>   </Link>

    </td><td/><td>
    <Link to="/upcoming-events#oct"><Typography variant="body1" fontSize="0.8rem">十月</Typography></Link>
    </td><td/><td>    <Link to="/upcoming-events#nov"><Typography variant="body1" fontSize="0.8rem">十一月</Typography> </Link>
    </td><td/>
     <td><Link to="/upcoming-events#dec"><Typography variant="body1" fontSize="0.8rem">十二月</Typography></Link>
     </td></tr>
     <tr id="jan"><td/><td colSpan={5}>
     {getEventsInMonth(0).map(e=>(<><img src={`/${e.poster}`} quality={40} loading="lazy" /><br/>{e.html}</>))}
     </td><td/>
   </tr>

  <tr id="feb"><td/><td colSpan={5}>
  {getEventsInMonth(1).map(e=>(<><img src={`/${e.poster}`} quality={40} loading="lazy" /><br/>{e.html}</>))}

    </td><td/>
  </tr>
  <tr id="mar"><td></td><td colSpan={5}>
  {getEventsInMonth(2).map(e=>(<><img src={`/${e.poster}`} quality={40} loading="lazy" /><br/>{e.html}</>))}

</td><td></td>
  </tr>
  <tr id="apr"><td></td><td colSpan={5}>
  {getEventsInMonth(3).map(e=>(<><img src={`/${e.poster}`} quality={40} loading="lazy" /><br/>{e.html}</>))}

</td><td></td>
  </tr>
  <tr id="may"><td></td><td colSpan={5}>
  {getEventsInMonth(4).map(e=>(<><img src={`/${e.poster}`} quality={40} loading="lazy" /><br/>{e.html}</>))}
   </td><td></td>
  </tr>
  <tr id="jun"><td></td><td colSpan={5}>
  {getEventsInMonth(5).map(e=>(<><img src={`/${e.poster}`} quality={40} loading="lazy" /><br/>{e.html}</>))}
</td><td></td>
  </tr>
  <tr id="jul"><td></td><td colSpan={5}>
  {getEventsInMonth(6).map(e=>(<><img src={`/${e.poster}`} quality={40} loading="lazy" /><br/>{e.html}</>))}

    </td><td></td>
  </tr>
  <tr id="aug"><td></td><td colSpan={5}>
  {getEventsInMonth(7).map(e=>(<><img src={`/${e.poster}`} quality={40} loading="lazy" /><br/>{e.html}</>))}

  </td><td></td>
  </tr>
  <tr id="sep"><td></td><td colSpan={5}>
  {getEventsInMonth(8).map(e=>(<><img src={`/${e.poster}`} quality={40} loading="lazy" /><br/>{e.html}</>))}

  </td><td></td>
  </tr>
  <tr id="oct"><td></td><td colSpan={5}>
  {getEventsInMonth(9).map(e=>(<><img src={`/${e.poster}`} quality={40} loading="lazy" /><br/>{e.html}</>))}

</td><td></td>
  </tr>
  <tr id="nov"><td></td><td colSpan={5}>
  {getEventsInMonth(10).map(e=>(<><img src={`/${e.poster}`} quality={40} loading="lazy" /><br/>{e.html}</>))}

    </td><td></td>
  </tr>
  <tr id="dec"><td></td><td colSpan={5}>
  {getEventsInMonth(11).map(e=>(<><img src={`/${e.poster}`} quality={40} loading="lazy" /><br/>{e.html}</>))}

</td><td></td>
  </tr>
  </tbody></Table>
    </Layout></>);
}

export default UpcomingEvents
